// The Timeline block's config, read the same way by both templates.
// No imports, so the harness can run it in node.

// A new block says what goes where rather than inventing a history,
// so a block nobody finished does not publish a founding year that
// never happened.
export const TIMELINE_DEFAULTS = [
    { date: 'Year founded', title: 'How it started', text: 'Who got together, and the first trail you worked on.', image: '', alt: '' },
    { date: 'Year', title: 'A partnership or a first', text: 'A landowner agreement, a grant, a new trail opening.', image: '', alt: '' },
    { date: 'This year', title: 'Where things stand', text: 'Miles you look after, crew days, what is next.', image: '', alt: '' },
];

// A milestone with neither a date nor a title is a half-added row in
// the editor. Rendered, it is a dot on the line with nothing beside
// it, which reads as something that failed to load.
export function timelineItems(config) {
    const rows = Array.isArray(config?.items) ? config.items : [];
    return rows
        .filter((r) => r && (String(r.date || '').trim() !== '' || String(r.title || '').trim() !== ''))
        .map((r) => ({
            date: String(r.date || '').trim(),
            title: String(r.title || '').trim(),
            text: String(r.text || '').trim(),
            image: String(r.image || '').trim(),
            alt: String(r.alt || '').trim(),
        }));
}
